module.exports = __webpack_public_path__ + "img/A58A2399.78aa2ac1.jpg";